/* =============================================
   ARACKAL JEWELLERY — HOMEPAGE JS
   File: assets/arackal-homepage.js
   ============================================= */

(function () {
  'use strict';

  /* ---- ARRIVALS SLIDESHOW ---- */
  function initArrivalsSlideshow() {
    var slides = document.querySelectorAll('.ak-arrivals__slide');
    var dots = document.querySelectorAll('.ak-arrivals__dot');
    var counter = document.querySelector('#ak-slide-num');
    if (!slides.length) return;

    var current = 0;
    var total = slides.length;
    var timer;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (n + total) % total;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      if (counter) counter.textContent = String(current + 1).padStart(2, '0');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(i);
        startTimer();
      });
    });

    function startTimer() {
      timer = setInterval(function () { goTo(current + 1); }, 4000);
    }

    startTimer();
  }

  /* ---- SCROLL REVEAL ---- */
  function initScrollReveal() {
    var elements = document.querySelectorAll('.ak-reveal');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      elements.forEach(function (el) { observer.observe(el); });
    } else {
      // Fallback: just show everything
      elements.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---- INIT ON DOM READY ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initArrivalsSlideshow();
    initScrollReveal();
  });

})();